import {SC_Input} from "../input/SC_Input";

export class ModUnique {
	private sID: string;
	private bModSEN: boolean;
	//Typ
	public sType: string;
	//Leistungstoleranz
	public sLeiTol: string;
	//Umpp
	public nUmpp: number;
	//Impp
	public nImpp: number;
	//Uoc
	public nUoc: number;
	//Isc
	public nIsc: number;
	//Usys
	public nUsys: number;
	//UC in %/K
	public nUC: number;
	//IC in %/K
	public nIC: number;
	//Rückstrom
	public nRStrom: number;
	//Variable für DC-Anschluss
	public sVarCab: string;
	constructor(_sID: string, _bModSEN: boolean) {
		this.sID = _sID;
		this.bModSEN = _bModSEN;
	}
	public isEqualInput(): boolean {
		if (this.sID == SC_Input.sModulID && this.bModSEN == SC_Input.bModSEN) {
			return true;
		}
		return false;
	}
	public setFromInput(): void {
		this.sID = SC_Input.sModulID;
		this.bModSEN = SC_Input.bModSEN;
	}
}